// State
// Types
export const GENERAL_USER_REDUCER = "GENERAL_USER_REDUCER";
export const CHANGE_TOKEN_STATE = "CHANGE_TOKEN_STATE";
export const CHANGE_CLIENT = "CHANGE_CLIENT";
export const RESET_USER_DATA = "RESET_USER_DATA";
